export type CmpConsentBridgeEvent = 'scriptsReady' | 'initialConsent' | 'consentChanged';

type CmpConsentBridgeHandler = (cmp: CbsOptanonCmp) => void;

export type CmpConsentBridgeState = {
    cmpBridgeInitialized: boolean;
    cachedCmp: CbsOptanonCmp | undefined;
    cmpRegistered: boolean;
    scriptsReadyRegistered: boolean;
    consentChangedRegistered: boolean;
    pollId: number | undefined;
    pollTimeoutId: number | undefined;
    firedEvents: Set<CmpConsentBridgeEvent>;
    subscribers: Record<CmpConsentBridgeEvent, Set<CmpConsentBridgeHandler>>;
};

export const CMP_CONSENT_BRIDGE_STATE_KEY = Symbol.for('@tn/foundation/cmp-consent-bridge/state');

function createCmpConsentBridgeState(): CmpConsentBridgeState {
    return {
        cmpBridgeInitialized: false,
        cachedCmp: undefined,
        cmpRegistered: false,
        scriptsReadyRegistered: false,
        consentChangedRegistered: false,
        pollId: undefined,
        pollTimeoutId: undefined,
        firedEvents: new Set(),
        subscribers: {
            scriptsReady: new Set(),
            initialConsent: new Set(),
            consentChanged: new Set(),
        },
    };
}

/**
 * Single bridge state per runtime — survives duplicate `@module-federation/nextjs-mf`
 * bundle copies so late-mounted remotes (e.g. video SmartTag) share pub/sub + replay.
 */
export function getCmpConsentBridgeState(): CmpConsentBridgeState {
    const cache = globalThis as Record<symbol, unknown>;
    let state = cache[CMP_CONSENT_BRIDGE_STATE_KEY] as CmpConsentBridgeState | undefined;
    if (!state) {
        state = createCmpConsentBridgeState();
        cache[CMP_CONSENT_BRIDGE_STATE_KEY] = state;
    }
    return state;
}

/** Test-only — not for production use. */
export function resetCmpConsentBridgeStateForTests(): void {
    const cache = globalThis as Record<symbol, unknown>;
    delete cache[CMP_CONSENT_BRIDGE_STATE_KEY];
}
